export const DEEP_LINK_COMMAND_QUERY_KEY = 'dl_command';
